<template>
  <div class="layout">
    <m-header @showPersonInfo="showPersonInfo"></m-header>
    <div class="ma-placeholder"></div>
    <transition name="fade-transform" mode="out-in">
      <router-view></router-view>
    </transition>
    <m-footer></m-footer>
    <m-chat></m-chat>
    <login v-if="showLogin"></login>
    <student-info></student-info>
    <el-dialog title="个人信息" :visible.sync="dialogVisible" width="569px" class="dialog" :close-on-click-modal="false">
      <div class="form-content">
        <div class="person-info">
          <el-upload :action="upAction" name="file" :headers="uploadHeader" :show-file-list="false"
            :on-success="uploadSuccess">
            <img v-if="mForm.avatar != null && mForm.avatar != ''" :src="mForm.avatar | fileFilter" class="img-size-c">
            <img v-if="mForm.avatar == null || mForm.avatar == ''" :src="img" class="img-size-c">
            <!-- <img class="img-size-c" :src="mForm.avatar | fileFilter" alt="" />
            <img class="img-size-c" :src="mForm.avatar | fileFilter" alt="" /> -->
          </el-upload>
          <p style="font-size: 24px;font-weight: bold;margin: 10px 0;">{{mForm.userName}}</p>
          <!--<span style="font-size: 13px;">{{mForm.sex | sexFilter}} &emsp;&emsp; 24岁</span>-->
        </div>
        <div>
          <el-form :rules="formRules" ref="mForm" :model="mForm" label-width="100px">
            <el-form-item label="姓名" prop="nickName" :label-width="formLabelWidth">
              <el-input v-model="mForm.nickName" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机" prop="phonenumber" :label-width="formLabelWidth">
              <el-input v-model="mForm.phonenumber" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" :label-width="formLabelWidth">
              <el-input v-model="mForm.email" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="原密码" prop="password" :label-width="formLabelWidth">
              <el-input v-model="mForm.password" autocomplete="off" clearable></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword" :label-width="formLabelWidth">
              <el-input v-model="mForm.newPassword" autocomplete="off" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="dialogVisible = false">取 消</el-button>
        <el-button type="text" @click="submitForm('mForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Auth from "@/utils/Auth"; // 验权
  import MHeader from "@/components/MHeader";
  import MFooter from "@/components/MFooter";
  import MChat from "@/components/MChat";
  import Login from "@/views/Login";
  import StudentInfo from "@/views/ManageStudy/StudentInfo";
  import WebSocketUtil from "@/utils/WebSocketUtil";
  import CommonFilters from "@/mixins/CommonFilters";
  export default {
    name: "Layout",
    mixins: [CommonFilters],
    components: { MHeader, MFooter, MChat, Login, StudentInfo },
    data () {
      return {
        dialogVisible: false,
        upAction: "",
        uploadHeader: {
          Authorization: ""
        },
        img: require("@/assets/avator02.png"),
        mForm: {},
        formRules: {
          nickName: [
            { required: true, message: "请输入", trigger: "change" }
          ],
          phonenumber: [
            { required: true, message: "请输入", trigger: "change" }
          ],
          email: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          newPassword: [
            { required: true, message: "密码不能为空,必须有大小写字母，最少6个字符，最多18位", pattern: /^(?=.*[A-Z])+(?=.*[a-z])[^]{6,18}$/, trigger: "change" }
          ],
        },
        formLabelWidth: "120px",
      }
    },
    computed: {
      userInfo () {
        return this.$store.state.user.userInfo;
      },
      showLogin () {
        return this.$store.state.app.showLogin;
      }
    },
    filters: {
      sexFilter (sex) {
        if (parseInt(sex) === 0) {
          return "男";
        } else if (parseInt(sex) === 1) {
          return "女";
        }
      }
    },
    methods: {
      showPersonInfo (val) {
        this.upAction = process.env.VUE_APP_PREFIX + "/fastdfs/upload/image/sample";
        this.uploadHeader.Authorization = Auth.getToken();
        /*
        this.mForm = {
            avatar: this.userInfo.avatar,
            age: this.userInfo.age,
            roleId: this.userInfo.roleId,
            roleKey: this.userInfo.roleKey,
            supplementFlag: this.userInfo.supplementFlag,
            classerId: this.userInfo.classerId,
            classerName: this.userInfo.classerName,
            phonenumber: this.userInfo.phonenumber,
            email: this.userInfo.email,
            userId: this.userInfo.userId,
            userName: this.userInfo.userName,
            nickName: this.userInfo.nickName,
            sex: this.userInfo.sex,
            newPassword: "",
            password: ""
        }
        this.dialogVisible = val;
   
         */


        // /system/user/getUser/{userId}
        // /system/user/edit
        let that = this;
        that.HttpConnection.get(`/system/user/getUser/${that.userInfo.userId}`).then(function (response) {
          let _userInfo = response.data;
          _userInfo.roleIds = response.roleIds;
          that.mForm = _userInfo;
          that.dialogVisible = val;
        });
      },
      submitForm (mForm) {
        let that = this;
        this.$refs[mForm].validate((valid) => {
          if (valid) {
            that.HttpConnection.put("/system/user/editmypwd", that.mForm).then(function (response) {
              that.$message({
                type: "info",
                message: "修改成功"
              });
              that.dialogVisible = false;
              that.HttpConnection.post("logout").then(function (res) {
                WebSocketUtil.closeWebSocket(true);
                Auth.removeToken();
                localStorage.clear();
                location.reload();
              });
            });
          }
        });
      },
      uploadSuccess (res, file) {
        this.mForm.avatar = res.filePath;
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "../styles/transition.scss";

  .form-content {
    display: flex;
    justify-content: center;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    padding: 30px;
  }

  .person-info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .img-size-c {
    width: 100px;
    height: 100px;
  }
</style>